import React from 'react';

interface MkdfLogoProps {
  /** ロゴの高さ(px) */
  height?: number;
  className?: string;
  /** trueの場合、ライト背景向けに色を反転する */
  lightBg?: boolean;
}

const MkdfLogo: React.FC<MkdfLogoProps> = ({ height = 24, className, lightBg = false }) => {
  return (
    <img
      src="/mkdf-logo.png"
      alt="MK-DF エムケーディーエフ"
      height={height}
      className={className}
      style={{
        display: 'inline-block',
        verticalAlign: 'middle',
        filter: lightBg ? 'invert(1)' : 'none',
        objectFit: 'contain',
      }}
    />
  );
};

export default MkdfLogo;
